import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  noSkuOrUpcError: {
    defaultMessage: 'No product found that contains SKU or UPC {value}.',
    id: '6nwMti',
    description: 'Error when product is not found by sku or upc',
  },
  scanUpcSku: {
    defaultMessage: 'Scan a UPC or SKU',
    id: 'uJY8GZ',
    description: 'Placeholder for UPC/SKU input',
  },
  workWithScanner: {
    defaultMessage: 'If using a scanner, you can continuously scan products without needing to enter each one individually.',
    id: 'wsx+Xm',
    description: 'Text informing how the functionality works with a scanner',
  },
  add: {
    defaultMessage: 'Add',
    id: 'w7gwCC',
    description: 'Text for add button',
  },
  bundleNotAllowed: {
    defaultMessage:
      'This product is a bundled product. Bundled products do not have their own inventory counts. Instead, you can scan the components of the bundle or create a kit to represent an assembled bundle',
    id: 'JPY6On',
    description: 'Informs that bundle cannot be added',
  },
});
